import CloudImg from "public/openStack/cloud.png";
import LightImg from "public/openStack/light.png";
import CubesImg from "public/openStack/cubes.png";
import VerifyImg from "public/openStack/tdesign_secured-filled.png";
import SecImg from "public/openStack/lock.png";

export const OFFERINGS_CONSTANTS = [
  {
    image: CloudImg,
    title: "Fully Managed Platform",
    text: "A product-grade OpenStack platform with zero ops overhead",
  },
  {
    image: LightImg,
    title: "Rapid Provisioning",
    text: "Rapid provisioning of compute, storage, and networking via UI, CLI, or API",
  },
  {
    image: CubesImg,
    title: "Seamless Integration",
    text: "Support for IaaS, Kubernetes, CI/CD, and hybrid environments",
  },
  {
    image: VerifyImg,
    title: "Enterprise Security",
    text: "Built-in security, compliance, and high availability",
  },
  {
    image: SecImg,
    title: "Vendor Freedom",
    text: "Open standards and automation-first design",
  },
];
